import Papa from 'papaparse'
import { O } from "../../ui"
import { VatCondition } from "../../../modules/administration"
import { Customer, CustomerCategory, useCustomerLoaders, useCustomerTypeLoaders, useCustomerActions, useCustomerBuilders } from "../../../modules/sales"
import { IdentifierType } from "../../../modules/system"
import { toList } from "../../../utils/listUtils"
import { capitalize } from "../../../utils/typeUtils"
import { useAddressBuilders } from "../../address"
import { FinalCustomerName } from "../../data-types"

const toNumber = (value?: string): number | undefined => {
    const numericChars = value?.replace(/[^0-9]/g, '')
    return numericChars ? Number(numericChars) : undefined
}

const getValue = (row: any, key: string): O<string> => {
    return row[key] || undefined
}

export const BooleanTrueValue = 'SI'

export const useImportCustomers = () => {
    const { buildCustomer, buildCreditAccount } = useCustomerBuilders()
    const { buildAddress } = useAddressBuilders()

    const customerLoaders = useCustomerLoaders()
    const customerTypeLoaders = useCustomerTypeLoaders()

    const { saveCustomers } = useCustomerActions()
    
    const load = async (e: any) => {
        const data = e.target?.result as string
        const result = Papa.parse<any>(data, {
            header: true,
            skipEmptyLines: true
        })
        const rows = result.data

        const { loadAllCustomerTypes } = customerTypeLoaders()
        const loadedCustomerTypes = await loadAllCustomerTypes()
        const { loadAllCustomers } = customerLoaders()
        const loadedCustomers = await loadAllCustomers()

        const customers: Customer[] = []
        const newCustomers: Customer[] = []

        for (const row of rows) {
            const address = capitalize(getValue(row, "Domicilio"))
            const locality = capitalize(getValue(row, "Localidad"))
            const province = capitalize(getValue(row, "Provincia"))
            const mainAddress = address ? buildAddress({
                address,
                locality,
                province
            }) : undefined
            
            const name = capitalize(getValue(row, "Razón social")?.toLowerCase())
            const identifierType = IdentifierType.TAX_ID
            const rawIdentifier = toNumber(getValue(row, "CUIT"))
            const identifier = rawIdentifier || 11111111111
            const category = getValue(row, "Categoría") as O<CustomerCategory>
            const customerTypeId = loadedCustomerTypes.find(loadedCustomerType => loadedCustomerType.name === FinalCustomerName)?.id
            const emails = toList(getValue(row, "Email")?.toLowerCase())
            const phones = toList(toNumber(getValue(row, "Teléfono")))
            const deliveryAddresses = toList(mainAddress)
            const vatCondition = (getValue(row, "Sit. ante IVA") || VatCondition.FINAL_CONSUMER) as VatCondition

            const hasCreditAccount = getValue(row, "Cuenta correntista")?.toUpperCase() === BooleanTrueValue
            const creditAccount = hasCreditAccount ? buildCreditAccount({
                creditLimit: 1000,
                creditDays: 30
            }) : undefined

            const loadedCustomer = loadedCustomers.find(loadedCustomer => loadedCustomer.identifier === identifier)
   
            const customer = buildCustomer({
                id: loadedCustomer?.id,
                name,
                identifierType,
                identifier,
                category,
                customerTypeId,
                emails,
                phones,
                mainAddress,
                deliveryAddresses,
                vatCondition,
                creditAccount
            })

            customers.push(customer)
            !loadedCustomer && newCustomers.push(customer)
        }

        console.log('updated customers:', customers.length - newCustomers.length)
        console.log('new customers:', newCustomers.length)
        await saveCustomers(customers)
    }
    
    return (
        file: File
    ) => {
        const reader = new FileReader()
        reader.onload = load
        reader.readAsText(file)
    }
}
